// Fronted/src/services/ministryService.js
import api from './api';

const ministryService = {
  getAllMinistries: async () => {
    try {
      const response = await api.get('/ministries');
      return response.data;
    } catch (error) {
      console.error('Error fetching ministries:', error);
      throw error;
    }
  },

  getMinistryById: async (id) => {
    try {
      const response = await api.get(`/ministries/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ministry ${id}:`, error);
      throw error;
    }
  },

  createMinistry: async (ministryData) => {
    try {
      const response = await api.post('/ministries', ministryData);
      return response.data;
    } catch (error) {
      console.error('Error creating ministry:', error);
      throw error;
    }
  },

  updateMinistry: async (id, ministryData) => {
    try {
      const response = await api.put(`/ministries/${id}`, ministryData);
      return response.data;
    } catch (error) {
      console.error(`Error updating ministry ${id}:`, error);
      throw error;
    }
  },

  deleteMinistry: async (id) => {
    try {
      const response = await api.delete(`/ministries/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting ministry ${id}:`, error);
      throw error;
    }
  },

  getMinistryByName: async (name) => {
    try {
      const response = await api.get(`/ministries/name/${name}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ministry by name ${name}:`, error);
      throw error;
    }
  }
};

export default ministryService; 